// function to create a sql request for table and map
export const defineDefinitionExpression = (
  pFiltres: object,
  pModule: string,
  pContractCode: string | null
) => {  
  let query: string =
    pModule !== 'indus' && pModule !== ''
      ? "ContractCode in ('" + pContractCode + "')"
      : '';
  let andLink = pModule !== 'indus' ? ' AND ' : '';

  Object.entries(pFiltres).forEach((filter: object) => {
    if (
      (filter[0] === 'Color' ||
        filter[0] === 'SensibilityColor' ||
        filter[0] === 'ColorBoonLister' ||
        filter[0] === 'ColorSejourCana' ||
        filter[0] === 'ColorSejourPR' ||
        filter[0] === 'ColorAutocurage' ||
        filter[0] === 'ColorTerrain' ||
        filter[0] === 'DilutionColor') &&
      filter[1].code !== ''
    ) {
      // for Color filter, values are already in string format
      query += andLink + filter[0] + ' in (' + filter[1].code + ')';
    } else if (filter[0] === 'YearFromCurrentYear' && filter[1].code !== '') {
      // for hydro (years filter)
      query += andLink + filter[0] + ' in (' + yearsReplace(filter[1]) + ')';
    } else {
      if (
        pModule !== 'indus' &&
        filter[0] !== 'allCommunes' &&
        filter[1].code !== '' &&
        filter[1].code !== undefined
      ) {
        query += andLink + filter[0] + " in ('" + filter[1].code + "')";
      } else {
        // indus case
        if (query !== '') {
          andLink = ' AND ';
        }
        if (filter[0] !== 'InseeCode' && filter[1].code !== '') {
          if (filter[0] !== 'WarsmannNote') {
            query += andLink + filter[0] + " in ('" + filter[1].code + "')";
          } else {
            query += andLink + filter[0] + ' in (' + filter[1].code + ')';
          }
        }
      }
    }
  });
  return query;
};

export const prepareMultipleInseeCodesRequest = (pCodes: any) => {
  let inseeCodes = '';
  pCodes.forEach((commune, index) => {
    if (commune.code !== undefined) {
      if (index === 0) {
        inseeCodes = inseeCodes + "'" + commune.code + "'";
      } else {
        inseeCodes = inseeCodes + ",'" + commune.code + "'";
      }
    }
  });
  return inseeCodes;
};

// translate value of radio buttons for query
export const yearsReplace = (pYears: any) => {
  let valueToReturn = '';
  if (pYears.red === true) {
    valueToReturn += '0,';
  }
  if (pYears.orange === true) {
    valueToReturn += '1,';
  }
  if (pYears.blue === true) {
    valueToReturn += '2,';
  }
  if (valueToReturn === '') {
    valueToReturn = '0,1,2,';
  }
  const valueToReturnUpdated = valueToReturn.slice(0, valueToReturn.length - 1);
  return valueToReturnUpdated;
};
